import { createContext, useContext } from 'react';
import type { Theme } from '../api/me';

export type { Theme };

/** Where a customer's choice is kept on this device. public/theme-init.js reads it too. */
export const THEME_STORAGE_KEY = 'loupe:theme';

export interface ThemeContextValue {
  /** The theme on screen: Lightbox (`light`) or Darkroom (`dark`). */
  theme: Theme;
  /** Switch theme. It's the customer's choice from then on, over the device setting. */
  setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
